import type { ReactNode } from 'react'

/** Friendly placeholder for an empty list, with an optional next action. */
export function EmptyState({
  icon,
  title,
  text,
  action,
}: {
  icon: ReactNode
  title: string
  text?: string
  action?: ReactNode
}) {
  return (
    <div className="empty">
      <span className="empty-icon" aria-hidden="true">
        {icon}
      </span>
      <h3>{title}</h3>
      {text !== undefined && <p>{text}</p>}
      {action}
    </div>
  )
}
